import {GetterTree} from 'vuex'
import {WidgetState} from "@/apps/MyStudyChoiceFavoritesWidget/models/store-viewmodel"
import {Config} from "@/apps/MyStudyChoiceFavoritesWidget/models/config-viewmodel";
import { IStudy, IStudies } from "@/shared/models/api/study-choice-studies-model";

export default <GetterTree<WidgetState, WidgetState>>{
    loading(state): boolean {
        return state.loading
    },
    innerLoading(state): boolean {
        return state.inner_loading
    },
    config(state): Config {
        return state.config
    },
    getStudies(state): IStudies {
        const studies = state.studies
        return studies.sort((a, b) => -1 * b.title.localeCompare(a.title))
    },
    getStudySearchModal(state): boolean {
        return state.study_search_modal
    },
    getFavoriteStudies(state): IStudies {
        return state.studies.filter(s => s.isFavorite == true)
    },
    getSearchQuery(state): string {
        return state.search_query
    }
}
